import React, { Component } from 'react';
import {
  PieChart,
  Pie,
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Sector,
  Tooltip,
  Legend,
  LabelList,
  Cell,
  CartesianGrid
} from 'recharts';

import { injectIntl, defineMessages } from 'react-intl';
//Brush

import { Icon, Image } from 'semantic-ui-react';
import { Tooltip as MeterialTooltip } from 'material-ui';

import { ExamChartInfo, Loading } from 'components';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import styles from './ExamChart.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamChart extends Component {
  constructor(props) {
    super(props);

    this.state = { isLoading: false, detailChartTab: 'division' };
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    // 데이터
    const {
      // 현재 경로
      currentPath,
      // [전체 훈련] 라인차트에서 현재 hover로 선택한 훈련 데이터
      // lineChartData,
      // 현재 선택한 훈련
      selectedExamSummaryNo,
      // (전체 훈련을 선택했을때) 선택된 훈련
      selectedExamList,
      // 훈련 요약 데이터 Ordering
      examSummaryOrdering,
      // 훈련 요약 데이터
      examSummaryByExamNo,
      // 훈련 목록 데이터
      examListByNo,
      // 차트 정보(소속별, 태그별 데이터)
      examChart
    } = this.props;
    // 기능
    const { onPieEnter, onLineChart } = this.props;

    let ChartComponent;
    // 전체 훈련 선택
    if (selectedExamSummaryNo === 'all') {
      if (examSummaryByExamNo.size === 0) {
        // 훈련이 없을 경우
        ChartComponent = (
          <div className={cx('emptyExam')}>
            {/* <Icon name="pie chart" /> */}
            <div className={cx('emptyExam-icon')}>
              <Image src="/img/exam/chart_noResult.png" />
            </div>
            <div>
              <div className={cx('emptyExam-title')}>
                {defineMessages(formatMessage({ id: 'ExamChart_1', defaultMessage: '훈련 결과 차트' }))}
              </div>
              <div className={cx('emptyExam-subtitle')}>
                {defineMessages(formatMessage({ id: 'ExamList_2', defaultMessage: '훈련을 실행해 보세요' }))}
              </div>
            </div>
          </div>
        );
      } else {
        // 각각 훈련 데이터 value 합친 데이터
        const dataInfoChart = {
          target: 0,
          send: 0,
          read: 0,
          download: 0,
          cure: 0,
          declare: 0,
          edu: 0,
          eduTarget: 0,
          infection: 0,
          // 악성 파일 감염 대상자 (피싱 제외)
          downloadN: 0,
          infectionN: 0,
          // 피싱 접속 대상자 (피싱만)
          downloadP: 0,
          infectionP: 0,
          infectionPc: 0,
          leakAllcount: 0,
          leakAllsize: 0,
          leakFileCount: 0,
          leakFileSize: 0,
          leakCertCount: 0,
          leakCertSize: 0,
          leakEmailCount: 0,
          leakEmailSize: 0,
          examType: 0,
          attachExamType: 0,
          linkAttach: 0
        };

        // 라인 차트
        const dataLineChart = [];
        examSummaryOrdering.map((examNo, index) => {
          // 하나도 선택 안했을 경우 전체 리스트 데이터 || 선택된 훈련에 대한 데이터
          if (selectedExamList.size === 0 || selectedExamList.indexOf(Number(examNo)) !== -1) {
            const examInnerData = examSummaryByExamNo.get(String(examNo));
            dataInfoChart.target += examInnerData.get('target');
            dataInfoChart.send += examInnerData.get('send');
            dataInfoChart.read += examInnerData.get('read');
            dataInfoChart.download += examInnerData.get('download');
            dataInfoChart.infection += examInnerData.get('infection');
            dataInfoChart.infectionPc += examInnerData.get('infectionPc');
            dataInfoChart.cure += examInnerData.get('cure');
            dataInfoChart.declare += examInnerData.get('declare');
            dataInfoChart.edu += examInnerData.get('edu');
            dataInfoChart.eduTarget += examInnerData.get('eduTarget');
            dataInfoChart.leakAllcount += examInnerData.get('leakAllcount');
            dataInfoChart.leakAllsize += examInnerData.get('leakAllsize');
            dataInfoChart.leakFileCount += examInnerData.get('leakFileCount');
            dataInfoChart.leakFileSize += examInnerData.get('leakFileSize');
            dataInfoChart.leakCertCount += examInnerData.get('leakCertCount');
            dataInfoChart.leakCertSize += examInnerData.get('leakCertSize');
            dataInfoChart.leakEmailCount += examInnerData.get('leakEmailCount');
            dataInfoChart.leakEmailSize += examInnerData.get('leakEmailSize');
            dataInfoChart.examType += examInnerData.get('examType');
            dataInfoChart.attachExamType += examInnerData.getIn(['attachData', 'attachExamType']);
            dataInfoChart.linkAttach += examInnerData.get('linkAttach');

            if (examInnerData.get('examType') === 4) {
              dataInfoChart.downloadP += examInnerData.get('download');
              dataInfoChart.infectionP += examInnerData.get('infection');
            } else {
              dataInfoChart.downloadN += examInnerData.get('download');
              dataInfoChart.infectionN += examInnerData.get('infection');
            }

            if (dataLineChart.length < 10) {
              dataLineChart.unshift({
                name: examInnerData.get('examName'),
                target: examInnerData.get('target'),
                send: examInnerData.get('send'),
                read: examInnerData.get('read'),
                download: examInnerData.get('download'),
                infection: examInnerData.get('infection'),
                infectionPc: examInnerData.get('infectionPc'),
                cure: examInnerData.get('cure'),
                declare: examInnerData.get('declare'),
                edu: examInnerData.get('edu'),
                eduTarget: examInnerData.get('eduTarget'),
                leakAllcount: examInnerData.get('leakAllcount'),
                leakAllsize: examInnerData.get('leakAllsize'),
                leakFileCount: examInnerData.get('leakFileCount'),
                leakFileSize: examInnerData.get('leakFileSize'),
                leakCertCount: examInnerData.get('leakCertCount'),
                leakCertSize: examInnerData.get('leakCertSize'),
                leakEmailCount: examInnerData.get('leakEmailCount'),
                leakEmailSize: examInnerData.get('leakEmailSize'),
                examType: examInnerData.get('examType'),
                attachExamType: examInnerData.getIn(['attachData', 'attachExamType']),
                linkAttach: examInnerData.get('linkAttach')
              });
            }
          }
        });

        const infectionPercent = Number((dataInfoChart.infection / dataInfoChart.target * 100).toFixed(0));

        const declarePercent = Number((dataInfoChart.declare / dataInfoChart.target * 100).toFixed(0));

        const eduPercent = Number((dataInfoChart.eduTarget / dataInfoChart.target * 100).toFixed(0));

        const infectionFileArray = [
          // 데이터가 없을때 표시
          {
            name: '',
            color: '',
            value: 100 - infectionPercent,
            percent: 100 - infectionPercent
          },
          {
            name: 'infection',
            color: '#db2828',
            value: infectionPercent,
            percent: infectionPercent
          }
        ];

        ChartComponent = (
          <div className={cx('chart-inner', 'allChart')}>
            <div className={cx('resultInfo')}>
              <div className={cx('resultInfo-content')}>
                {/* 감염율 */}
                <div className={cx('resultInfo-infectionChart')}>
                  {/* 악성 파일 감염율 이미지 넣기 */}
                  <div className={cx('infectionChart-icon')}>
                    <Image src="/img/exam/chart/all_danger.png" />
                  </div>
                  {/* 차트 넣어야 함 */}
                  <PieChart width={120} height={120}>
                    <Pie
                      dataKey="percent"
                      data={[
                        {
                          name: 'background',
                          percent: 100
                        }
                      ]}
                      cx={55}
                      cy={55}
                      innerRadius={47}
                      outerRadius={57}
                      startAngle={90}
                      endAngle={450}
                      paddingAngle={0}>
                      <Cell fill="#e6e6e6" />
                    </Pie>
                    <Pie
                      dataKey="percent"
                      data={infectionFileArray}
                      cx={55}
                      cy={55}
                      innerRadius={47}
                      outerRadius={57}
                      startAngle={90}
                      endAngle={450}
                      paddingAngle={0}
                      activeIndex={0}
                      activeShape={e => {
                        const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, value } = e;
                        return (
                          <g>
                            {/* 그라데이션 효과 */}
                            <defs>
                              <linearGradient id="db2828" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#ff6c00" />
                                <stop offset="100%" stopColor="#ff0b72" />
                              </linearGradient>
                            </defs>
                            <Sector
                              cx={cx}
                              cy={cy}
                              innerRadius={innerRadius}
                              outerRadius={outerRadius}
                              startAngle={startAngle}
                              endAngle={endAngle}
                              fill="rgb(230,230,230)"
                            />
                            {/* 차트의 확장 처리 */}
                            <Sector
                              cx={cx}
                              cy={cy}
                              startAngle={startAngle}
                              endAngle={endAngle}
                              innerRadius={outerRadius}
                              outerRadius={outerRadius}
                              fill={fill}
                              cornerRadius={10}
                            />
                          </g>
                        );
                      }}>
                      {/* cell 안에 그라데이션 효과 */}
                      {infectionFileArray.map((entry, index) => (
                        <Cell cornerRadius={10} key={index} fill={'url(' + entry.color + ')'} />
                      ))}
                    </Pie>
                  </PieChart>
                  <div className={cx('infectionChart-text')}>
                    <div className={cx('infectionChart-text-1')}>
                      {defineMessages(formatMessage({ id: 'ExamChart_31', defaultMessage: '위험 대상자' }))}
                    </div>
                    <div className={cx('infectionChart-text-2')}>
                      <span className={cx('value')}>{dataInfoChart.infection}</span>
                      <span className={cx('ea')}>
                        {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  </div>
                </div>
                {/* 각 세부 정보 */}
                <div className={cx('resultInfo-detail')}>
                  {/* 상단 정보 */}
                  <div className={cx('resultInfo-header')}>
                    <div className={cx('resultInfo-target')}>
                      <Image src="/img/exam/chart/all_target.png" />
                      <div className={cx('resultInfo-target-title')}>
                        {defineMessages(formatMessage({ id: 'ExamChart_33', defaultMessage: '누적 훈련 대상' }))}
                      </div>
                      <div className={cx('resultInfo-target-content')}>
                        <span className={cx('value')}>{dataInfoChart.target}</span>
                        <span className={cx('ea')}>
                          {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={cx('resultInfo-header')}>
                    <div className={cx('resultInfo-infection')}>
                      <Image src="/img/exam/chart/all_infectionPer.png" />
                      <div className={cx('resultInfo-infection-title')}>
                        {defineMessages(formatMessage({ id: 'ExamChart_2', defaultMessage: '감염율' }))}
                      </div>
                      <div className={cx('resultInfo-infection-content')}>
                        <span className={cx('value')}>{infectionPercent}</span>
                        <span className={cx('ea')}>%</span>
                      </div>
                    </div>
                    {commonVar.isDeclare === 1 && <div className={cx('divider')} />}
                    {commonVar.isDeclare === 1 && (
                      <MeterialTooltip
                        title={
                          defineMessages(formatMessage({ id: 'Declare_1', defaultMessage: '누적 신고 대상' })) +
                          ': ' +
                          dataInfoChart.declare +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))
                        }
                        placement="bottom">
                        <div className={cx('resultInfo-infection')}>
                          <Image src="/img/declare/result_icon.png" />
                          <div className={cx('resultInfo-infection-title')}>
                            {defineMessages(formatMessage({ id: 'Declare_2', defaultMessage: '신고율' }))}
                          </div>
                          <div className={cx('resultInfo-infection-content')}>
                            <span className={cx('value')}>{declarePercent}</span>
                            <span className={cx('ea')}>%</span>
                          </div>
                        </div>
                      </MeterialTooltip>
                    )}
                    {/* {commonVar.isEdu === 1 && <div className={cx('divider')} />}
                    {commonVar.isEdu === 1 && (
                      <MeterialTooltip
                        title={
                          '교육 훈련 비율 대상: ' +
                          dataInfoChart.eduTarget +
                          defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))
                        }
                        placement="bottom">
                        <div className={cx('resultInfo-infection')}>
                          <Image src="/img/edu/result_icon.png" />
                          <div className={cx('resultInfo-infection-title')}>학습율</div>
                          <div className={cx('resultInfo-infection-content')}>
                            <span className={cx('value')}>{eduPercent}</span>
                            <span className={cx('ea')}>%</span>
                          </div>
                        </div>
                      </MeterialTooltip>
                    )} */}
                  </div>
                  {/* 세부정보 줄 */}
                  <div className={cx('resultInfo-detail-each')}>
                    <div className={cx('each-info-area')}>
                      <div className={cx('each-info-icon')}>
                        <Image src="/img/exam/chart/all_send.png" />
                      </div>
                      <div className={cx('each-info-content')}>
                        <div className={cx('title')}>
                          {defineMessages(formatMessage({ id: 'ExamSummaryItem_10', defaultMessage: '메일 발송' }))}
                        </div>
                        <div className={cx('content')}>
                          <span className={cx('value')}>{dataInfoChart.send}</span>
                          <span className={cx('ea')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className={cx('each-info-area')}>
                      <div className={cx('each-info-icon')}>
                        <Image src="/img/exam/chart/all_down.png" />
                      </div>
                      <div className={cx('each-info-content')}>
                        <div className={cx('title')}>
                          {defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                        </div>
                        <div className={cx('content')}>
                          <span className={cx('value')}>{dataInfoChart.downloadN}</span>
                          <span className={cx('ea')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className={cx('each-info-area')}>
                      <div className={cx('each-info-icon')}>
                        <Image src="/img/exam/chart/all_infection.png" />
                      </div>
                      <div className={cx('each-info-content')}>
                        <div className={cx('title')}>
                          {defineMessages(formatMessage({ id: 'ExamDetail_3', defaultMessage: '감염 대상' }))}
                        </div>
                        <div className={cx('content')}>
                          <span className={cx('value')}>{dataInfoChart.infectionN}</span>
                          <span className={cx('ea')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={cx('resultInfo-detail-each')}>
                    <div className={cx('each-info-area')}>
                      <div className={cx('each-info-icon')}>
                        <Image src="/img/exam/chart/all_read.png" />
                      </div>
                      <div className={cx('each-info-content')}>
                        <div className={cx('title')}>
                          {defineMessages(formatMessage({ id: 'ExamSummaryItem_12', defaultMessage: '메일 열람' }))}
                        </div>
                        <div className={cx('content')}>
                          <span className={cx('value')}>{dataInfoChart.read}</span>
                          <span className={cx('ea')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className={cx('each-info-area')}>
                      <div className={cx('each-info-icon')}>
                        <Image src="/img/exam/chart/all_access.png" />
                      </div>
                      <div className={cx('each-info-content')}>
                        <div className={cx('title')}>
                          {defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))}
                        </div>
                        <div className={cx('content')}>
                          <span className={cx('value')}>{dataInfoChart.downloadP}</span>
                          <span className={cx('ea')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={cx('each-info-area')}>
                      <div className={cx('each-info-icon')}>
                        <Image src="/img/exam/chart/all_leak.png" />
                      </div>
                      <div className={cx('each-info-content')}>
                        <div className={cx('title')}>
                          {defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))}
                        </div>
                        <div className={cx('content')}>
                          <span className={cx('value')}>{dataInfoChart.infectionP}</span>
                          <span className={cx('ea')}>
                            {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ----------------------- 라인 차트 ----------------------- */}
            <div className={cx('lineChart-area')}>
              <LineChart
                width={370}
                height={200}
                data={dataLineChart}
                margin={{ top: 35, right: 10, left: 0, bottom: 35 }}>
                <YAxis
                  tickLine={false}
                  // tickCount={4}
                  axisLine={false}
                // height={1}
                />
                <CartesianGrid vertical={false} stroke="#eeeeee" />
                <Tooltip content={onLineChart.tooltip} />
                <Line type="linear" dataKey="target" stroke="#14ae96" strokeWidth={1.9} dot={false} isAnimationActive={false} />
                <Line type="linear" dataKey="send" stroke="#ffcf0e" strokeWidth={1.3} dot={false} isAnimationActive={false} />
                <Line type="linear" dataKey="read" stroke="#f69c2e" strokeWidth={1.5} dot={false} isAnimationActive={false} />
                <Line type="linear" dataKey="download" stroke="#711bd1" strokeWidth={1.5} dot={false} isAnimationActive={false} />
                <Line type="linear" dataKey="infection" stroke="#db2828" strokeWidth={1.5} dot={false} isAnimationActive={false} />
                <Line type="linear" dataKey="cure" stroke="#1ba8d1" strokeWidth={1.5} dot={false} isAnimationActive={false} />
                <Legend
                  iconSize={10}
                  width={260}
                  height={30}
                  layout="vertical"
                  verticalAlign="middle"
                  wrapperStyle={{
                    top: 190,
                    left: 80,
                    lineHeight: '20px'
                  }}
                  content={({ payload }) => {
                    return (
                      <div className={cx('lineChart-legend', 'custom-message')}>
                        {payload.map((entry, index) => (
                          <div className={cx('each-item')} key={index}>
                            <div className={cx('color')} style={{ backgroundColor: entry.color }} />
                            <div className={cx('message')}>
                              {entry.value === 'target' &&
                                defineMessages(formatMessage({ id: 'ExamChart_5', defaultMessage: '대상' }))}
                              {entry.value === 'send' &&
                                defineMessages(formatMessage({ id: 'ExamChart_4', defaultMessage: '발송' }))}
                              {entry.value === 'read' &&
                                defineMessages(formatMessage({ id: 'ExamChart_3', defaultMessage: '열람' }))}
                              {entry.value === 'download' &&
                                defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' }))}
                              {entry.value === 'infection' &&
                                defineMessages(formatMessage({ id: 'ExamChart_11', defaultMessage: '감염' }))}
                              {entry.value === 'cure' &&
                                defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }))}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  }}
                />
              </LineChart>
            </div>
            {/* ---------- 전체 훈련에서 현재 선택된 개별 훈련 정보 ---------- */}
          </div>
        );
      }
    } else {
      // ---------------------------------------------- 개별 훈련 -------------------------------------------
      const examData = examSummaryByExamNo.get(String(selectedExamSummaryNo));

      if (!examData) {
        ChartComponent = (
          <div className={cx('emptyExam')}>
            <Icon name="pie chart" />
            {defineMessages(formatMessage({ id: 'ExamChart_1', defaultMessage: '훈련 결과 차트' }))}
          </div>
        );
      } else {
        // ----------------------- 소속별 차트 데이터 -----------------------
        const detailChartColors = [
          '#db2828',
          '#f2711c',
          '#fbbd08',
          '#b5cc18',
          '#21ba45',
          '#2185d0',
          '#6435c9',
          '#a333c8',
          '#e03997',
          '#a5673f',
          '#767676',
          '#1b1c1d'
        ];

        let examChartArray;
        let detailChartKeys = {};
        if (currentPath === '/main/exam/pi') {
          // ----------- 대상별 차트 -----------
          // 소속별
          if (this.state.detailChartTab === 'division') {
            detailChartKeys = {
              emptyName: defineMessages(formatMessage({ id: 'ExamChart_12', defaultMessage: '소속 없음' })),
              name: 'targetDivision',
              chartType: 'pi'
            };

            examChartArray = examChart.getIn(['data', 0, 'division']);

            // 직급별
          } else {
            detailChartKeys = {
              emptyName: defineMessages(formatMessage({ id: 'ExamChart_29', defaultMessage: '직급 없음' })),
              name: 'targetPosition',
              chartType: 'pi'
            };

            examChartArray = examChart.getIn(['data', 0, 'position']);
          }
        } else {
          examChartArray = examChart.getIn(['data', 'tag']);

          // ----------- 태그별 차트 -----------
          detailChartKeys = {
            emptyName: defineMessages(formatMessage({ id: 'ExamChart_14', defaultMessage: '태그가 없는 대상자' })),
            name: 'tagName',
            chartType: 'tag'
          };
        }

        const detailDataArray = [];
        const detailChartInner = [];
        if (examChart.get('data') && examChart.get('data').size > 0 && !!examChartArray) {
          examChartArray.map((chartData, index) => {
            // 감염대상이 없는 경우는 제외
            if (chartData.get('infection') > 0) {
              detailDataArray.push({
                name: !!chartData.get(detailChartKeys.name)
                  ? chartData.get(detailChartKeys.name)
                  : '(' + detailChartKeys.emptyName + ')',
                infectionCnt: chartData.get('infection'),
                infectionText:
                  chartData.get('infection') +
                  defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })),
                percent:
                  (detailChartKeys.name === 'tagName'
                    ? (chartData.get('infection') / chartData.get('targetCount') * 100).toFixed(0)
                    : (chartData.get('infection') / examData.get('infection') * 100).toFixed(0)) + '%',
                total: detailChartKeys.name === 'tagName' ? chartData.get('targetCount') : examData.get('infection')
              });
            }
          });

          if (detailDataArray.length > 0) {
            // value 값으로 정렬
            common.ArraySort(detailDataArray, 'desc', 'infectionCnt').map((detailItemData, index) =>
              detailChartInner.push(
                <div className={cx('description-item')} key={index}>
                  <MeterialTooltip title={detailItemData.name} placement="bottom">
                    <div
                      className={cx('name ellipsis')}
                      style={{ color: detailChartColors[index % detailChartColors.length] }}>
                      {detailItemData.name}
                    </div>
                  </MeterialTooltip>
                  <div className={cx('progress')}>
                    <MeterialTooltip
                      title={
                        defineMessages(formatMessage({ id: 'ExamChart_2', defaultMessage: '감염율' })) +
                        ': ' +
                        (detailItemData.infectionCnt > 1 && detailItemData.percent === 0 ? 1 : detailItemData.percent) +
                        ' (' +
                        detailItemData.infectionCnt +
                        '/' +
                        detailItemData.total +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })) +
                        ')'
                      }
                      placement="bottom">
                      <div className={cx('custom-progress')}>
                        <div
                          className={cx('bar')}
                          style={{
                            width: detailItemData.percent,
                            backgroundColor: detailChartColors[index % detailChartColors.length]
                          }}
                        />
                      </div>
                    </MeterialTooltip>
                  </div>
                  <div className={cx('count')}>
                    {detailItemData.infectionCnt}
                    {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                  </div>
                </div>
              )
            );
          } else {
            detailChartInner.push(
              <div key={0} className={cx('noInfection')}>
                <Icon name="checkmark box" />
                {defineMessages(formatMessage({ id: 'ExamChart_24', defaultMessage: '감염 대상 없음' }))}
              </div>
            );
          }

          // 감염 대상자가 하나도 없음 (양호한상태)
        } else {
          detailChartInner.push(
            <div key={0} className={cx('noInfection')}>
              <Icon name="checkmark box" />
              {defineMessages(formatMessage({ id: 'ExamChart_24', defaultMessage: '감염 대상 없음' }))}
            </div>
          );
        }

        const infectionFileArray = [
          // 데이터가 없을때 표시
          {
            name: '',
            color: '',
            value: examData.get('leakAllcount') > 0 ? 0 : 100,
            count: '',
            file: '',
            label: '',
            percent: examData.get('leakAllcount') > 0 ? 0 : 100,
            percentLabel: ''
          },
          {
            name: 'pc',
            color: '#43cbaa',
            value: examData.get('leakFileCount'),
            file:
              common.fileSizeTrans(examData.get('leakFileSize')).size +
              common.fileSizeTrans(examData.get('leakFileSize')).unit,
            label: defineMessages(formatMessage({ id: 'ExamDetail_9', defaultMessage: 'pc파일' })),
            percent: (examData.get('leakFileCount') / examData.get('leakAllcount') * 100).toFixed(0),
            percentLabel: (examData.get('leakFileCount') / examData.get('leakAllcount') * 100).toFixed(0) + '%'
          },
          {
            name: 'cert',
            color: '#7b3faf',
            value: examData.get('leakCertCount'),
            file:
              common.fileSizeTrans(examData.get('leakCertSize')).size +
              common.fileSizeTrans(examData.get('leakCertSize')).unit,
            label: defineMessages(formatMessage({ id: 'ExamDetail_10', defaultMessage: '인증서' })),
            percent: (examData.get('leakCertCount') / examData.get('leakAllcount') * 100).toFixed(0),
            percentLabel: (examData.get('leakCertCount') / examData.get('leakAllcount') * 100).toFixed(0) + '%'
          },
          {
            name: 'email',
            color: '#6697da',
            value: examData.get('leakEmailCount'),
            file:
              common.fileSizeTrans(examData.get('leakEmailSize')).size +
              common.fileSizeTrans(examData.get('leakEmailSize')).unit,
            label: defineMessages(formatMessage({ id: 'ExamDetail_11', defaultMessage: '이메일' })),
            percent: (examData.get('leakEmailCount') / examData.get('leakAllcount') * 100).toFixed(0),
            percentLabel: (examData.get('leakEmailCount') / examData.get('leakAllcount') * 100).toFixed(0) + '%'
          }
        ];

        // 상세 감염 차트의 높이를 유동적으로 반영
        let lineChartHeight = detailDataArray.length * 35;
        if (lineChartHeight < 170) {
          lineChartHeight = 170;
        }

        // 피싱 유도 타입의 훈련 양식
        const isPhishing = 4 === examData.get('examType') ? true : false;

        ChartComponent = (
          <div className={cx('chart-inner', 'eachChart')}>
            {/* 훈련 상태 차트 */}
            <ExamChartInfo chartData={examData.toJS()} />

            {/* ----------------------- 감염 PC 차트 ----------------------- */}
            {1 === examData.get('examType') ? (
              <PieChart width={210} height={230} className={cx('mr-30')}>
                <Pie
                  dataKey="value"
                  data={[
                    {
                      name: 'background',
                      value: 100
                    }
                  ]}
                  cx={110}
                  cy={98}
                  paddingAngle={0}
                  innerRadius={31}
                  outerRadius={80}>
                  <Cell fill="#f7f7f7" />
                </Pie>
                <Pie
                  dataKey="value"
                  data={infectionFileArray}
                  cx={110}
                  cy={98}
                  innerRadius={39}
                  outerRadius={72}
                  startAngle={450}
                  endAngle={90}
                  paddingAngle={-1}
                  activeIndex={0}
                  activeShape={e => {
                    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = e;
                    return (
                      <g>
                        {/* 그라데이션 효과 */}
                        <text
                          x={cx}
                          y={cy - 12}
                          dy={18}
                          textAnchor="middle"
                          fill="#757575"
                          fontSize={12}
                          fontWeight={'bold'}>
                          {defineMessages(formatMessage({ id: 'ExamHeader_20', defaultMessage: '감염 파일' }))}
                        </text>
                        {/* 파일 */}
                        <defs>
                          <linearGradient id="43cbaa" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#39cbd2" />
                            <stop offset="50%" stopColor="#77eadf" />
                            <stop offset="100%" stopColor="#28c3a4" />
                          </linearGradient>
                        </defs>
                        {/* 인증서 */}
                        <defs>
                          <linearGradient id="7b3faf" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#753eaa" />
                            <stop offset="50%" stopColor="#a33ede" />
                            <stop offset="100%" stopColor="#6e19cc" />
                          </linearGradient>
                        </defs>
                        {/* 이메일 */}
                        <defs>
                          <linearGradient id="6697da" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#619dd8" />
                            <stop offset="100%" stopColor="#6649d2" />
                          </linearGradient>
                        </defs>

                        {/* 차트의 기본 형태 영역 */}
                        <Sector
                          cx={cx}
                          cy={cy}
                          innerRadius={innerRadius}
                          outerRadius={outerRadius}
                          startAngle={startAngle}
                          endAngle={endAngle}
                          fill="rgb(247, 247, 247)"
                        />
                        {/* 차트의 확장 처리 */}
                        <Sector
                          cx={cx}
                          cy={cy}
                          startAngle={startAngle}
                          endAngle={endAngle}
                          innerRadius={outerRadius - 1}
                          outerRadius={outerRadius + 8}
                          fill="rgb(247, 247, 247)"
                        />
                      </g>
                    );
                  }}>
                  {/* cell 안에 퍼센트 표시 */}
                  {infectionFileArray.map((entry, index) => <Cell key={index} fill={'url(' + entry.color + ')'} />)}
                </Pie>
                <Legend
                  iconSize={10}
                  width={190}
                  height={30}
                  layout="vertical"
                  verticalAlign="middle"
                  wrapperStyle={{
                    top: 194,
                    left: 25,
                    lineHeight: '20px'
                  }}
                  content={({ payload }) => {
                    return (
                      <div className={cx('chart2-legend', 'custom-message')}>
                        {payload.map((entry, index) => {
                          if (entry.value === 'pc' || entry.value === 'cert' || entry.value === 'email') {
                            return (
                              <div className={cx('each-item')} key={index}>
                                <div className={cx('color')} style={{ backgroundColor: entry.payload.color }} />
                                <div className={cx('message')}>
                                  {entry.value === 'pc' &&
                                    defineMessages(formatMessage({ id: 'ExamDetail_9', defaultMessage: 'pc파일' }))}
                                  {entry.value === 'cert' &&
                                    defineMessages(formatMessage({ id: 'ExamDetail_10', defaultMessage: '인증서' }))}
                                  {entry.value === 'email' &&
                                    defineMessages(formatMessage({ id: 'ExamDetail_11', defaultMessage: '이메일' }))}
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    );
                  }}
                />
                <Tooltip
                  content={({ payload }) => {
                    return payload.map((entry, index) => {
                      if (entry.name === 'pc' || entry.name === 'cert' || entry.name === 'email') {
                        return (
                          <div className={cx('chart2-tooltip')} key={index}>
                            <div className={cx('name')}>{entry.payload.label}</div>
                            <div className={cx('value')}>
                              {entry.value +
                                defineMessages(formatMessage({ id: 'ExamHeader_2', defaultMessage: '개' })) +
                                ' (' +
                                entry.payload.file +
                                ')'}
                            </div>
                          </div>
                        );
                      }
                    });
                  }}
                />
              </PieChart>
            ) : (
                <div />
              )}

            {/* ----------------------- 소속별 감염 대상 / 태그별 감염 대상 ----------------------- */}
            <div
              className={cx(
                'eachExam-detailChart',
                { division: this.state.detailChartTab === 'division' },
                { position: this.state.detailChartTab === 'position' }
              )}>
              {this.state.isLoading && (
                <div className={cx('ChartLoading')}>
                  <Loading content={'Loading...'} />
                </div>
              )}
              {detailChartKeys.chartType === 'pi' ? (
                <div className={cx('chart-name')}>
                  <div
                    className={cx('chart-name-each tab-division')}
                    onClick={() => {
                      this.setState({ isLoading: true });
                      this.setState({ detailChartTab: 'division' });
                      setTimeout(() => {
                        this.setState({ isLoading: false });
                      }, 500);
                    }}>
                    {isPhishing
                      ? defineMessages(formatMessage({ id: 'ExamChart_26', defaultMessage: '소속별 정보 유출 대상' }))
                      : defineMessages(formatMessage({ id: 'ExamChart_13', defaultMessage: '소속별 감염 대상' }))}
                  </div>
                  <div
                    className={cx('chart-name-each tab-position')}
                    onClick={() => {
                      this.setState({ isLoading: true });
                      this.setState({ detailChartTab: 'position' });
                      setTimeout(() => {
                        this.setState({ isLoading: false });
                      }, 500);
                    }}>
                    {isPhishing
                      ? defineMessages(formatMessage({ id: 'ExamChart_27', defaultMessage: '직급별 정보 유출 대상' }))
                      : defineMessages(formatMessage({ id: 'ExamChart_25', defaultMessage: '직급별 감염 대상' }))}
                  </div>
                </div>
              ) : (
                  <div className={cx('chart-name')}>
                    <div className={cx('chart-name-each tab-tag')}>
                      {isPhishing
                        ? defineMessages(formatMessage({ id: 'ExamChart_28', defaultMessage: '태그별 정보 유출 대상' }))
                        : defineMessages(formatMessage({ id: 'ExamChart_15', defaultMessage: '태그별 감염 대상' }))}
                    </div>
                  </div>
                )}

              <div className={cx('chart-content')}>
                {detailDataArray.length > 0 ? (
                  <BarChart
                    className={cx('barChart-wrap')}
                    layout="vertical"
                    width={350}
                    height={lineChartHeight}
                    data={detailDataArray}
                    margin={{ top: 10, right: 60, bottom: 10, left: 10 }}>
                    {/* <CartesianGrid horizontal={false} stroke="#eeeeee" /> */}
                    <XAxis hide type="number" />
                    <YAxis dataKey="name" width={90} tickLine={false} tickSize={10} type="category" />
                    <Tooltip
                      // viewBox
                      cursor={false}
                      content={({ payload }) => {
                        return (
                          <div>
                            {payload.map((entry, index) => (
                              <div className={cx('barChart-toolTip')} key={index}>
                                <div className={cx('name')}>{entry.payload.name}</div>
                                <div className={cx('value')}>
                                  {entry.payload.infectionCnt +
                                    defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      }}
                    />
                    <Bar dataKey="infectionCnt" barSize={7} fill="#14ae96" isAnimationActive={false}>
                      <LabelList
                        fill="#777777"
                        position="right"
                        content={props => {
                          const { x, y, width, value } = props;

                          return (
                            <g>
                              <text
                                x={x + width + 20}
                                y={y + 7}
                                fill="#333333"
                                textAnchor="middle"
                                dominantBaseline="middle">
                                <tspan className={cx('detailChartBar-title')}>{value}</tspan>
                                <tspan className={cx('detailChartBar-content')}>
                                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                                </tspan>
                              </text>
                            </g>
                          );
                        }}
                      />
                    </Bar>
                  </BarChart>
                ) : (
                    <div className={cx('chart-noData')}>
                      <Image src="/img/exam/chart_noData.png" />
                      <div className={cx('chart-noData-text')}>
                        {isPhishing
                          ? defineMessages(formatMessage({ id: 'ExamChart_32', defaultMessage: '정보 유출 대상자 없음' }))
                          : defineMessages(formatMessage({ id: 'ExamChart_30', defaultMessage: '감염 대상자 없음' }))}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        );
      }
    }

    return <div className={cx('examChart-wrapper')}>{ChartComponent}</div>;
  }
}

export default injectIntl(ExamChart);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamChart.js